import { createContext, ReactNode, useMemo } from "react";
import { useRouteLoaderData } from "react-router-dom";
import type { RootLoader } from "@/types/RootLoader";
import { ProviderConfig } from "./types";
import { defaultConfig, getProviderConfig } from "./index";

export const ProviderConfigContext =
  createContext<ProviderConfig>(defaultConfig);

// Routes/features are gated on what the account API says the provider is,
// not on the ?provider= URL param — the URL and sessionStorage are both
// user-controlled, so trusting them here would let a SamCart account reach
// the Plans tab and every automation just by dropping the query param.
// Reads userStatus.provider (authorization-server's AuthProviderView), not
// accountInfo.providerIdentifier — that field is an unrelated accountservice
// lookup key (e.g. a Shopify shop domain) and is never populated with the
// SAMCART/SHOPIFY/... provider type this gating actually needs.
export function ProviderConfigProvider({ children }: { children: ReactNode }) {
  const { userStatus } = useRouteLoaderData("root") as RootLoader;
  const provider = userStatus?.provider ?? null;
  const config = useMemo(() => getProviderConfig(provider), [provider]);

  return (
    <ProviderConfigContext.Provider value={config}>
      {children}
    </ProviderConfigContext.Provider>
  );
}
